import React, { useState, useEffect } from "react";
import {
    XMarkIcon,
    CheckIcon,
    MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { getMemberList, setSelectedChat, setEmptyMessages } from "@/store/slices/chatSlice";
import { useTranslation } from "react-i18next";


const CreateSingleChat = ({ onCancel, onSuccess }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('chat');
    const { chat_list, member_list, member_list_pagination, member_list_loading } = useSelector(
        (state) => state.chat
    );
    const hasMore = member_list_pagination?.has_more ?? false;

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        setPage(1);
        dispatch(getMemberList({ page: 1, search, reset: true }));
    }, [dispatch, search]);

    const fetchMoreMembers = () => {
        if (!hasMore || member_list_loading) return;
        const nextPage = page + 1;
        setPage(nextPage);
        dispatch(getMemberList({ page: nextPage, search }));
    };

    const toggleMember = (user) => {
        setSelectedUser(user);
    };

    const handleSubmit = async () => {
        const chat = {
            "conversation_id": null,
            "type": "user",
            "chat_with": {
                "id": selectedUser?.user_id,
                "name": selectedUser?.full_name,
                "image": selectedUser?.profile_image
            },
            "isNewChatCreated":true,
        };
        dispatch(setSelectedChat(chat));
        // dispatch(setEmptyMessages([]));
        onSuccess();
    };

    const existingUserIds = new Set(
        chat_list
            ?.filter(c => c.type === "user")
            ?.map(c => c.chat_with?.id)
    );


    return (
        <div className="flex flex-col h-full bg-white relative">

            {/* Header */}
            <div className="p-4 flex items-center gap-2">
                {/* <button onClick={onCancel}>
                    <XMarkIcon className="h-6 w-6 text-[#333333DE]" />
                </button> */}

                <div className="relative flex-grow">
                    <MagnifyingGlassIcon className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#333333DE]" />
                    <input
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder={t('searchMembers')}
                        className="w-full bg-[#0000000A] rounded-full py-2 pl-9 pr-4 text-sm focus:outline-none focus:ring-1 focus:ring-[#00a884] placeholder-[#736C64]"
                    />
                    {search && <XMarkIcon className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 text-[#333333DE] cursor-pointer" onClick={() => setSearch('')} />}
                    
                </div>
            </div>
            <div id="usersScroll" className="flex-grow overflow-y-auto px-4 pb-24">
                <InfiniteScroll
                    dataLength={member_list?.length}
                    next={fetchMoreMembers}
                    hasMore={hasMore}
                    scrollableTarget="usersScroll"
                    loader={<div className="flex justify-center mb-4">
                        <div className="h-6 w-6 border-2 border-gray-400 border-t-[#065C36] rounded-full animate-spin"></div>
                    </div>}
                    endMessage={
                        <p className="text-center text-gray-400 py-6 text-sm">
                            {member_list?.length === 0 ? t('noUserFound') : ""}
                        </p>
                    }
                >
                    {member_list?.length>0 && member_list
                        .filter(u => !existingUserIds.has(u.user_id))
                        .map((u) => (
                        <div
                            key={u.user_id}
                            onClick={() => toggleMember(u)}
                            className="flex justify-between items-center p-3 hover:bg-gray-50 rounded-xl cursor-pointer"
                        >
                            <div className="flex items-center gap-3">
                                <img
                                    src={u.profile_image || "/img/icons/user-profile.png"}
                                    className="w-11 h-11 rounded-full object-cover"
                                />
                                    <div className="flex flex-col">
                                        <span className="text-sm font-semibold">
                                            {u.full_name}
                                        </span>
                                        <span className="text-xs text-gray-500">
                                            {u.user_role}
                                        </span>
                                    </div>
                            </div>

                            <div
                                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedUser?.user_id === u.user_id
                                        ? "bg-[#065C36] border-[#065C36]"
                                        : "border-gray-300"
                                    }`}
                            >
                                {selectedUser?.user_id === u.user_id && (
                                    <CheckIcon className="h-3 w-3 text-white stroke-[3]" />
                                )}
                            </div>
                        </div>
                    ))}
                </InfiniteScroll>
            </div>

            <div className="absolute bottom-6 right-6">
                <button
                    // disabled={!singleChat}
                    onClick={handleSubmit}
                    className={`w-12 h-12 rounded-xl flex items-center justify-center ${selectedUser?.user_id ? "bg-[#065C36] text-white" : "bg-gray-200 text-gray-400"
                        }`}
                >
                    <CheckIcon className="h-6 w-6" />
                </button>
            </div>
        </div>
    );
};

export default CreateSingleChat;
